import {inject, Injectable} from '@angular/core';
import {DEFAULT_MIN_TOKEN_VALIDITY} from './defaults';
import Keycloak from 'keycloak-js';
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEvent} from 'keycloak-angular';

@Injectable({
    providedIn: 'root'
})
export class KeycloakWrapperService {

    public keycloakProfile: any;
    private instance: Keycloak;
    private readonly _keycloakSignalToken = inject(KEYCLOAK_EVENT_SIGNAL);
    private _keycloakSignal: KeycloakEvent;

    public setInstance(instance: Keycloak): void {
        this.instance = instance;
    }

    public setKeycloakSignal(): void {
        this._keycloakSignal = this._keycloakSignalToken();
    }

    public get keycloakSignal(): KeycloakEvent {
        return this._keycloakSignal;
    }

    public updateToken(minValidity?: number): Promise<boolean> {
        return this.instance.updateToken(minValidity ?? DEFAULT_MIN_TOKEN_VALIDITY);
    }

    public getKeycloakInstance(): Keycloak.KeycloakInstance {
        return this.instance;
    }

    public get authenticated(): boolean {
        return this.instance?.authenticated ?? false;
    }

    public logout(): Promise<void> {
        return this.instance.logout();
    }

    public login(config?: any): Promise<void> {
        return this.instance.login(config);
    }

    public get token(): string {
        return this.instance.token;
    }

}
